import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import producerProfilesApi from 'api/requests/producerProfiles';
import ToastContainer from 'components/_UI/ToastsContainer';
import useToast from 'hooks/useToast';
import EmailCampaignsPanel from '../customers/EmailCampaignsPanel';

export default function CampaignsPage() {
    const [events, setEvents] = useState([]);
    const { toast, toasts } = useToast();

    useEffect(() => {
        fetchEventsForFilter();
    }, []);

    async function fetchEventsForFilter() {
        try {
            const [{ data: activeData }, { data: expiredData }] = await Promise.all([
                producerProfilesApi.getMeEvents('active', 1, 50),
                producerProfilesApi.getMeEvents('expired', 1, 50),
            ]);
            setEvents([...(activeData?.data || []), ...(expiredData?.data || [])]);
        } catch (err) {
            // Sem lista de eventos só desativa a segmentação por evento/combinação
            // dentro do composer — a campanha pra "todos os clientes" continua ok.
        }
    }

    return (
        <Page>
            <EmailCampaignsPanel events={events} toast={toast} />
            <ToastContainer toasts={toasts} />
        </Page>
    );
}

const Page = styled.div`
    width: 100%;
`;
